import React from 'react';
import { TrainListItem } from './CovidTrainsListItem';
import PropTypes from 'prop-types';

const CovidEpassTrains = ({ trainsList, onClicked, pageName }) => {
  return (
    <>
      <ul className="makeFlex column">
        {trainsList &&
          trainsList.map((train, idx) => {
            return <TrainListItem key={idx} train={train} onClick={onClicked} pageName={pageName} />;
          })}
      </ul>
    </>
  );
};

CovidEpassTrains.propTypes = {
  trainsList: PropTypes.array,
  onClicked: PropTypes.func,
  pageName: PropTypes.string
};

CovidEpassTrains.defaultProps = {
  trainsList: null,
  onClicked: undefined,
  pageName: ''
};

export default CovidEpassTrains;
